<template>
  <div data-app>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="6" md="6" style="color: #e33354" class="ml-4">
            <h3>{{ cardTitle }}</h3>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('FORMS.search')"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="filingBookCollection"
          :search="search"
          :sort-by="['id']"
          sort-desc="true"
          :loading="loadingTable"
          @dblclick:row="handleClickItem"
          :footer-props="{
            'items-per-page-options': [100],
          }"
        >
          <template #header="{ props: { headers } }">
            <thead class="v-data-table-header">
              <tr>
                <th></th>
                <th>
                  <v-select
                    v-model="yearFilter"
                    :items="['Minden év', ...yearCollection]"
                  ></v-select>
                </th>
                <th>
                  <v-select
                    v-model="statusFilter"
                    :items="['Minden státusz', ...statusCollection]"
                  ></v-select>
                </th>
                <th></th>
              </tr>
            </thead>
          </template>

          <template v-slot:top>
            <v-toolbar flat>
              <FilingBookModalForm
                :modalData="modalData"
                :permissions="permissions"
                :statuses="statuses"
                :endPoint="endPoint"
                @closeModalForm="handleCloseModalForm"
                @saveModalForm="handleSaveModalForm"
                @new="handleNew"
              ></FilingBookModalForm>
              <v-spacer></v-spacer>
              <DeleteModalDialog
                :dialogDelete="dialogDelete"
                @closeDelete="handleCloseDelete"
                @deleteItemConfirm="handleDeleteItemConfirm"
              >
              </DeleteModalDialog>
            </v-toolbar>
          </template>
          <!-- <template v-slot:item.status="{ item }">
            <span>{{ item.status }}</span>
          </template> -->
          <template v-slot:item.name="{ item }">
            <v-icon color="primary" small>flaticon-folder</v-icon>
            &nbsp;
            {{ item.name }}
          </template>

          <template v-slot:item.actions="{ item }">
            <router-link
              :to="`/settings/filings/filingBooks/${item.id}`"
              v-if="permissionCan('view')"
            >
              <v-icon small class="mr-2"> mdi-pencil </v-icon>
            </router-link>

            <v-icon
              color="primary"
              v-if="permissionCan('delete') && item.filings.length == 0"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { listModelsMixins } from "@/view/mixins/listModelsMixins.js";

import FilingBookModalForm, { initialFormData } from "./FilingBookModalForm";

import DeleteModalDialog from "@/view/components/DeleteModalDialog";

export const PERMISSION_TO = "filings.filingBook.";

export default {
  name: "FilingBooks",
  components: { FilingBookModalForm, DeleteModalDialog },
  mixins: [listModelsMixins],
  data() {
    return {
      cardTitle: this.$t("MENU.FILING_BOOKS"),
      search: "",
      routePath: "/settings/filings/filingBooks/",
      permissionTo: PERMISSION_TO,
      permissions: JSON.parse(localStorage.permissions),
      headers: [
        // {
        //   text: this.$t("TABLE.translated"),
        //   value: "translated",
        //   width: "100px",
        // },
        {
          text: this.$t("TABLE.filingBooks"),
          value: "name",
        },
        {
          text: this.$t("TABLE.year"),
          value: "year",
          filter: (value) => {
            if (this.yearFilter == "Minden év") return true;
            return +value == +this.yearFilter;
          },
        },
        {
          text: "Status",
          value: "status",
          filter: (value) => {
            if (this.statusFilter == "Minden státusz") return true;
            return value == this.statusFilter;
          },
        },

        {
          text: this.$t("TABLE.actions"),
          value: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      listEndPoint: "filings/admin/filingBook/",

      modalData: {
        dialog: false,
        editedId: null,
      },
      editedItem: Object.assign({}, initialFormData()),

      dialogDelete: false,

      statusFilter: "Aktív",
      yearFilter: `${new Date().getFullYear()}`,
      statusCollection: ["Aktív", "Inaktív", "Lezárt"],
    };
  },

  computed: {
    ...mapGetters(["filingBookCollection", "statuses"]),

    endPoint() {
      return "filings/admin/filingBook/";
    },

    yearCollection() {
      return (
        this.filingBookCollection
          // .filter((i) => i.status)
          .map((item) => {
            return item.year;
          })
      );
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.handleCloseDelete();
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },

    "$route.params.filingBookId": {
      handler: function (filingBookId) {
        if (filingBookId) {
          // this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(["fetchFilingBook"]),

    handleClickItem(event, item) {
      if (
        this.permissionCan("view") &&
        !this.dialogDelete &&
        !this.modalData.dialog
      ) {
        this.$router.push(`/settings/filingBooks/${item.item.id}/filings/`);
      }
    },

    fetchModel() {
      return this.fetchFilingBook();
    },
  },

  mounted() {
    this.loadingTable = true;
    this.fetchModel().then(() => (this.loadingTable = false));
  },
};
</script>
